var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGabon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_436)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.756 26.9565C39.56 24.79 40 22.4464 40 20C40 17.5536 39.56 15.2103 38.756 13.0436L20 11.3044L1.24398 13.0436C0.440078 15.2103 0 17.5536 0 20C0 22.4464 0.440078 24.79 1.24398 26.9565L20 28.6957L38.756 26.9565Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 40C28.5993 40 35.9303 34.5725 38.7561 26.9565H1.24402C4.06996 34.5725 11.4007 40 20.0001 40Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 3.05176e-05C11.4007 3.05176e-05 4.06996 5.42753 1.24402 13.0435H38.7561C35.9303 5.42753 28.5993 3.05176e-05 20.0001 3.05176e-05Z",
    fill: "#6DA544"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_436"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGabon);
export default __webpack_public_path__ + "static/media/gabon.1d1d087b8cb49dc7d36c19ce634b894e.svg";
export { ForwardRef as ReactComponent };